export default [
  {
    name: 'Pending',
    menuName: 'Pending Hires',
    value: 'PENDING',
    class: 'info',
    tooltip: 'Needs to be collected',
  },
  {
    name: 'Unassigned',
    menuName: 'Unassigned Hires',
    value: 'UNASSIGNED',
    class: 'warning',
    tooltip: 'Needs a vehicle assigning',
  },
  {
    name: 'Ready',
    menuName: 'Ready to Go',
    value: 'READY',
    class: 'warning',
    tooltip: 'Needs to be dispatched',
  },
  {
    name: 'Active',
    menuName: 'Due Back',
    value: 'ACTIVE',
    class: 'primary',
    tooltip: 'Currently out on hire',
  },
  {
    name: 'On-Hold',
    menuName: 'Returns',
    value: 'ON-HOLD',
    class: 'danger',
    tooltip: 'Returned, but needs to be resolved',
  },
  {
    name: 'Complete',
    menuName: 'Completed Hires',
    value: 'COMPLETE',
    class: 'success',
    tooltip: 'Hire has been completed',
  },
  {
    name: 'Did Not Attend',
    menuName: 'Cancelled Hires',
    value: 'CANCELLED',
    class: 'danger',
    tooltip: 'Hire was cancelled and could not be completed',
  },
];
